var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMoreMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 10.833C10.4596 10.833 10.8327 10.4599 10.8327 9.99967C10.8327 9.53944 10.4596 9.16634 9.99935 9.16634C9.53911 9.16634 9.16602 9.53944 9.16602 9.99967C9.16602 10.4599 9.53911 10.833 9.99935 10.833Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 4.99967C10.4596 4.99967 10.8327 4.62658 10.8327 4.16634C10.8327 3.7061 10.4596 3.33301 9.99935 3.33301C9.53911 3.33301 9.16602 3.7061 9.16602 4.16634C9.16602 4.62658 9.53911 4.99967 9.99935 4.99967Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 16.6663C10.4596 16.6663 10.8327 16.2932 10.8327 15.833C10.8327 15.3728 10.4596 14.9997 9.99935 14.9997C9.53911 14.9997 9.16602 15.3728 9.16602 15.833C9.16602 16.2932 9.53911 16.6663 9.99935 16.6663Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreMenu);
export default __webpack_public_path__ + "static/media/icon-more-menu.c67a13f4edd6c857974fa8c7693fcae7.svg";
export { ForwardRef as ReactComponent };